import React, { useState } from "react";
import { dataHandlers } from "../../utils/objectHandlers";
import { useSelector,useDispatch } from "react-redux";
import { addUploadedImages } from "../../Store/reducers/fabricCanvasSlice";

const Upload = () => {
  const dispatch = useDispatch();
  const fabricCanvas = useSelector((state) => state.fabricCanvas.fabricCanvas);  
  const images = useSelector((state) => state.fabricCanvas.uploadedImages); 

  // const [images, setImages] = useState([
  //   {
  //     url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRrDI3_Z4lF3ZuIrsdETTbhluBc6CM1OoTPBg&s",
  //   },
  //   {
  //     url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQV-FNtwRTrgGyEJRJo2AizK7FEiXo0qEi03w&s",
  //   },
  //   {
  //     url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ6yDwzdA4hrr6QAa7Zd-QeSLpZcZFz7-Lwig&s",
  //   },
  //   {
  //     url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQDJM3uk6j7TiGK50qCr6bdmM5SXBIEn-bdzg&s",
  //   },
  // ]);

  const handleFileUpload = (event) => {
    const files = Array.from(event.target.files);
    const uploadedFiles = files.map((file) => ({
      url: URL.createObjectURL(file),
      file,
    }));
    dispatch(addUploadedImages(uploadedFiles)); 
  };

  const handleDragStart = (e, imgObj) => {
    const isSVGFile =
      (imgObj.file && imgObj.file.type === "image/svg+xml") ||
      (!imgObj.file && imgObj.url.toLowerCase().endsWith(".svg"));

    if (isSVGFile) {
      e.dataTransfer.setData("svg", imgObj.url);
    } else {
      e.dataTransfer.setData("image", imgObj.url);
    }
  };

  const handleAddImage = (imgObj) => {
    if (fabricCanvas) {
      const centerX = fabricCanvas.getWidth() / 2;
      const centerY = fabricCanvas.getHeight() / 2;

      const isSVGFile =
        (imgObj.file && imgObj.file.type === "image/svg+xml") ||
        (!imgObj.file && imgObj.url.toLowerCase().endsWith(".svg"));
      console.log("isSVGFile:", isSVGFile);

      if (isSVGFile) {
        if (imgObj.file) {
          dataHandlers.svgFile(imgObj.file, fabricCanvas, {
            left: centerX,
            top: centerY,
          });
        } else {
          dataHandlers.svg(imgObj.url, fabricCanvas, {
            left: centerX,
            top: centerY,
          });
        }
      } else {
        dataHandlers.image(imgObj.url, fabricCanvas, {
          left: centerX,
          top: centerY,
        });
      }
    }
  };

  return (
    <div className="w-full">
      <div className="flex p-2 items-center justify-center">
        <label
          htmlFor="file-upload"
          className="font-montserrat font-semibold bg-black w-[241px] h-[32px] rounded-lg text-white text-[12px] flex items-center justify-center cursor-pointer"
        >
          Upload SVG, PNG, JPG
        </label>
        <input
          id="file-upload"
          type="file"
          accept=".svg,.png,.jpg,.jpeg"
          multiple
          onChange={handleFileUpload}
          className="hidden"
        />
      </div>

      <div className="h-[1px] w-full bg-gray-200 my-4" />

      <div className="w-full h-[435px] p-3 rounded-lg overflow-y-scroll custom-scrollbar">
        <div className="font-semibold text-black mb-2">Recently Uploaded</div>
        <div className="grid grid-cols-2 gap-2 cursor-pointer w-full">
          {images.map((imgObj, index) => (
            <div
              key={index}
              className="flex justify-center"
              draggable
              onDragStart={(e) => handleDragStart(e, imgObj)}
              onClick={() => handleAddImage(imgObj)}
            >
              <img
                src={imgObj.url}
                alt={`Recently uploaded image ${index + 1}`}
                className="w-[107px] h-[104px] object-cover rounded-lg"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Upload;
